// 公共的方法

const tools = {
  // 函数防抖，
  // 在事件被触发n秒后再执行回调，如果在这n秒内又被触发，则重新计时。
  debounce (fun, delay) {
    return function (args) {
      let that = this
      let _args = args
      clearTimeout(fun.id)
      fun.id = setTimeout(function () {
          fun.call(that, _args)
      }, delay)
    }
  },

  // 函数节流
  // 规定在一个单位时间内，只能触发一次函数。如果这个单位时间内触发多次函数，只有一次生效。
  throttle (fun, delay) {
    let last, deferTimer
    return function (args) {
      let that = this
      let _args = args
      let now = +new Date()
      if (last && now < last + delay) {
        clearTimeout(deferTimer)
        deferTimer = setTimeout(function () {
          last = now
          fun.apply(that, _args)
        }, delay)
      } else {
        last = now
        fun.apply(that, _args)
      }
    }
  },

  // 多个异步函数，同时执行，等待全部完成回调
  waitAll (funcList, ready) {
    if (funcList.length === 0) return ready && ready()
    let readyLength = funcList.length

    funcList.forEach(func => {
      func(() => {
        readyLength--

        if (readyLength === 0 && ready) {
          ready && ready()
        }
      })
    })
  },

  // 多个异步函数，顺序执行，等待全部完成回调
  waitSeries (funcList, ready) {
    if (funcList.length === 0) return ready && ready()
    let readyLength = funcList.length
    let index = 0

    function loopFunc (func) {
      func(() => {
        if (index === readyLength) {
          ready && ready()
        } else {
          loopFunc(funcList[index ++])
        }
      })
    }

    loopFunc(funcList[index ++])
  },

  // 循环等待一个方法，知道返回特定的值
  // waitUntil (func, interval, checkFunc) {
  //   const waitInterval = window.setInterval(() => {
  //     let func
  //   }, interval)
  // },

  // 生成随机字符串
  randomStr (length, types) {
    // 生成随机字符串
    const small = 'abcdefghijklmnopqrstuvwxyz'
    const big = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const number = '0123456789'
    const symbol = ',.!?@#$%'
    
    let str = ''
    let result = ''
  
    switch (types) {
      case 'small':
        str = small
        break
      case 'big':
        str = big
        break
      case 'symbol':
        str = symbol
        break
      default:
        str = small + number
    }
  
    // 根据字符长度，循环n次，生成随机字符
    for (let i = 0; i < length; i++) {
      result += str[Math.floor(Math.random() * str.length)]
    }
  
    return result
  },

  // 深度合并对象，不只是合并子属性一级
  mergeDeep (FirstOBJ, SecondOBJ) {
    for (var key in SecondOBJ) {

      if (FirstOBJ[key] === undefined) {
        // 无值
  
        if (typeof SecondOBJ[key] === 'object' && SecondOBJ[key] !== null) {
          // 对象
          FirstOBJ[key] = JSON.parse(JSON.stringify(SecondOBJ[key]))
  
        } else {
          // 非对象
          FirstOBJ[key] = SecondOBJ[key]
        }
      } else if (typeof SecondOBJ[key] === 'object' && SecondOBJ[key] !== null) {
        // 有值 且 是对象
        this.mergeDeep(FirstOBJ[key], SecondOBJ[key])
      }
    }
    return FirstOBJ
  },

  // 检测是否支持clip-path
  areClipPathShapesSupported: function () {

    let base = 'clipPath',
        prefixes = [ 'webkit', 'moz', 'ms', 'o' ],
        properties = [ base ],
        testElement = document.createElement( 'testelement' ),
        attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)'

    // Push the prefixed properties into the array of properties.
    for ( let i = 0, l = prefixes.length; i < l; i++ ) {
      // remember to capitalize!
      let prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 )
      properties.push( prefixedProperty )
    }

    // Interate over the properties and see if they pass two tests.
    for ( let j = 0, le = properties.length; j < le; j++ ) {
      let property = properties[j]

      // First, they need to even support clip-path (IE <= 11 does not)...
      if ( testElement.style[property] === '' ) {
        // Second, we need to see what happens when we try to create a CSS shape...
        testElement.style[property] = attribute;
        if ( testElement.style[property] !== '' ) {
          return true
        }
      }
    }

    return false
  }
}


export default tools
